module.exports = {"SundayFirst":false,"buttons":{"cancel":"Close"},"dismissable":true,"format":"YYYY-MM-DD","placeholder":"Select pick up date","type":"day","inputClass":"form-control","month":["January","February","March","April","May","June","July","August","September","October","November","December"],"week":["Mo","Tu","We","Th","Fr","Sa","Su"]}


//////////////////
// WEBPACK FOOTER
// ./static/js/date-picker-config.json
// module id = 43
// module chunks = 1